module.exports = __webpack_public_path__ + "img/lil_speaker_guy.ae537387.png";